//$(document).foundation()

jQuery(document).bind('gform_post_render', function(event, form_id, current_page) {

  $('.ginput_container_radio li').each(function() {
    if ($(this).find('span.radio-btn').length == 0) {
      $(this).find('input').after('<span class="radio-btn"></span>')
    }
  })

  // placeholder
  $('select').each(function() {
    var $select = $(this)
    var $button = $(this).parent().find('button')
    if ($(this).find('option.gf_placeholder').length > 0) {
      $select.on('change', (event) => {
        var val = $(this).val()
        if (val == '') {
          $select.addClass('has-placeholder')
          $button.addClass('has-placeholder')
        } else {
          $select.removeClass('has-placeholder')
          $button.removeClass('has-placeholder')
        }
      }).trigger('change')
    }
  })

  // select
  $('.ginput_container_select').each(function() {
    var $select = $(this).find('select')

    if ($select.hasClass('select-initialized') == false) {
      $select.addClass('select-initialized')
      var $form = $(this).closest('form')

      var numberOfOptions = $select.children('option').length
      $select.addClass('select-hidden')
      $select.wrap('<div class="select"></div>')
      $select.after('<button class="select-styled" aria-haspopup="true" aria-expanded="false"></button>')

      var $selectWrap = $select.closest('.select')

      var $styledSelect = $select.next('button.select-styled')
      $styledSelect.text($select.children('option').eq(0).text())

      var $list = $('<ul />', {
          'class': 'select-options'
      }).insertAfter($styledSelect)

      for (var i = 0; i < numberOfOptions; i++) {
        if ($select.children('option').eq(i).text() != 'Select One') {
          $('<li />', {
            text: $select.children('option').eq(i).text(),
            rel: $select.children('option').eq(i).val(),
            tabindex: 0
          }).appendTo($list).keypress(function(e) {
            if (e.which == 32 || e.which == 13) {
              $(this).trigger('click');
              e.preventDefault();
            }
          })
          if ($select.children('option').eq(i).is(':selected')) {
            $styledSelect.text($select.children('option').eq(i).text())
          }
        }
      }

      var $listItems = $list.children('li')

      $styledSelect.on('click', function(e) {
        e.stopPropagation()
        e.preventDefault()
        $selectWrap.toggleClass('active')
        if ($selectWrap.hasClass('active')) {
          $('.ginput_container_select .select').removeClass('active')
          $selectWrap.addClass('active')
        }
      })

      $listItems.on('click', function(e) {
        e.stopPropagation()
        $styledSelect.text($(this).text()).removeClass('active')
        $select.val($(this).attr('rel'))
        $select.trigger('change')
        $selectWrap.removeClass('active')
      })

      $(document).on('click', function() {
        $styledSelect.removeClass('active')
        $selectWrap.removeClass('active')
      })

    }
  })

})

jQuery(document).ready(function($) {

  var pageLoading = false
  var $article = $('article')
  var $body = $('body')
  var isLoggedIn = $('body').hasClass('logged-in')

  doBinds()

  $(window).on('popstate', function (event) {
    loadPage(window.location.href)
  })

  function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  }

  function loadPage(url) {
    $.ajax({
      url: url,
      cache: true,
      dataType: 'html',
      beforeSend: function(xhr) {
        $('html, body').animate({ scrollTop: 0 }, 500)
        $body.addClass('loading')
        pageLoading = true
      }
    }).done(function(html) {
      var articleHtml = $(html).filter('.page').find('article').html()
      var classes = $(html).filter('.page').data('body-class')
      var newPageTitle = $(html).filter('.page').data('page-title')
      $body.removeClass().addClass(classes).addClass('loading')
      setTimeout(function() {
        $article.html(articleHtml)
        doBinds()
      }, 300)
      setTimeout(function() {
        $body.removeClass('loading')
      }, 600)
      pageLoading = false
      document.title = newPageTitle
      // google analytics
      if (typeof _gaq !== 'undefined') {
        _gaq.push(['_trackPageview'])
      }
    }).fail(function(error) {
      alert('Error loading ' + href)
    })

  }

  function doBinds() {

    // project page images - reflow
    $('.single-project .list').imagesLoaded(function() {
      $(document).foundation()
    })

    // fancy load
    $('a[data-state]').off('click').on('click', function(e) {
      if (pageLoading == false && isLoggedIn == false) {
        $('body').removeClass('mobile-menu--is-open')
        var url = $(this).attr('href')
        if (url !== window.location.href) {
          history.pushState(null, null, url)
          loadPage(url)
        }
        e.preventDefault()
        e.stopPropagation()
      }
    })

    // publications show more
    $('.awards .more').on('click', function(e) {
      $('.awards .cell.hide').slice(0, 6).removeClass('hide')
      if ($('.awards .cell.hide').length == 0) {
        $(this).remove()
      }
      e.preventDefault()
      e.stopPropagation()
    })

    // publications show more
    $('.publications .more').on('click', function(e) {
      $('.publications .cell.hide').slice(0, 6).removeClass('hide')
      if ($('.publications .cell.hide').length == 0) {
        $(this).remove()
      }
      e.preventDefault()
      e.stopPropagation()
    })

    // publication hover
    $('.publications .box').hover(
      function(e) {
        if (Foundation.MediaQuery.atLeast('medium')) {
          e.stopPropagation()
          $(this).addClass('box--is-hovered')
        }
      },
      function(e) {
        if (Foundation.MediaQuery.atLeast('medium')) {
          e.stopPropagation()
          $(this).removeClass('box--is-hovered')
        }
      }
    )

    $('.publications .box').on('click', function(e) {
      if (Foundation.MediaQuery.current == 'small') {
        e.stopPropagation()
        $('.publications .box').removeClass('box--is-hovered')
        $(this).addClass('box--is-hovered')
      }
    })

    // studio bios
    $('.people .box').on('click', function() {
      var $people = $(this).closest('.people')
      var $box = $(this)
      var id = $box.data('id')
      var $profile = $people.find('.grid-profile[data-id="' + id + '"]')
      var $payload = $profile.closest('.payload')
      $people.find('.payload').removeClass('payload--is-showing')
      $people.find('.box').removeClass('active')
      $box.addClass('active')
      $payload.addClass('payload--is-showing').find('.grid-profile').removeClass('grid-profile--is-showing')
      $profile.addClass('grid-profile--is-showing')
      setTimeout(function() {
        $('html, body').animate({ scrollTop: $box.offset().top - 75 }, 300)
      }, 300)
    })

    // studio close
    $('.people .close').on('click', function(e) {
      e.preventDefault()
      var $payload = $(this).closest('.payload')
      var $people = $payload.closest('.people')
      $payload.removeClass('payload--is-showing')
      $people.find('.box').removeClass('active')
    })

    // process carousel phases
    if ($('.page-template-page-process').length > 0) {
      var $carouselPhasesLeft = $('.carousel-phases-left').flickity({
        cellSelector: '.carousel-cell',
        pageDots: false,
        prevNextButtons: false,
        percentPosition: false,
        autoPlay: 0,
        imagesLoaded: true,
        adaptiveHeight: false,
        setGallerySize: false,
        fade: true,
        draggable: true,
        resize: true,
        on: {
          select: function() {
            if ($carouselPhasesLeft) {
              var currentIndex = $carouselPhasesLeft.data('flickity').selectedIndex
              $carouselPhasesRight.flickity('select', currentIndex)
              $('.page-template-page-process .phases .dot').removeClass('active').eq(currentIndex).addClass('active')
              $('.active-dot').removeClass('dot-0-active dot-1-active dot-2-active dot-3-active dot-4-active')
              $('.active-dot').addClass('dot-' + currentIndex + '-active')
            }
          }
        }
      })
      var $carouselPhasesRight = $('.carousel-phases-right').flickity({
        cellSelector: '.carousel-cell',
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
        percentPosition: false,
        autoPlay: 0,
        imagesLoaded: true,
        resize: true,
        fade: true,
        wrapAround: true,
        draggable: false,
      })
      $('.carousel-phases-left-container .previous').on('click', function() {
        $carouselPhasesLeft.flickity('previous')
      })
      $('.carousel-phases-left-container .next').on('click', function() {
        $carouselPhasesLeft.flickity('next')
      })
      $('.page-template-page-process .phases .dot').on('click', function() {
        var $dot = $(this)
        $carouselPhasesLeft.flickity('select', $dot.index())
      })
    }

    // carousel featured
    if ($('.carousel-home').length > 0) {
      var $carouselHome = $('.carousel-home').flickity({
        cellSelector: '.carousel-cell',
        setGallerySize: false,
        pageDots: false,
        prevNextButtons: false,
        percentPosition: false,
        autoPlay: 4000,
        pauseOnHover: false,
        imagesLoaded: true,
        adaptiveHeight: true,
        fade: true,
        wrapAround: true,
        draggable: true,
        on: {
          select: function() {
            if ($carouselHome) {
              var currentIndex = $carouselHome.data('flickity').selectedIndex
              $carouselLabels.flickity('select', currentIndex)
            }
          }
        }
      })
      var $carouselLabels = $('.carousel-labels').flickity({
        cellSelector: '.carousel-cell',
        pageDots: false,
        prevNextButtons: false,
        percentPosition: false,
        autoPlay: 0,
        imagesLoaded: true,
        adaptiveHeight: true,
        wrapAround: true,
        fade: true,
        draggable: false
      })
      $('.carousel-home-container .previous').on('click', function() {
        $carouselHome.flickity('previous')
      })
      $('.carousel-home-container .next').on('click', function() {
        $carouselHome.flickity('next')
      })
      // scroll
      $(window).off('scroll').on('scroll', function() {
        var carouselHomeHeight = $('.carousel-home-container').height()
        if ($(window).scrollTop() > 0) {
          $('header').addClass('header--is-scrolled')
        } else {
          $('header').removeClass('header--is-scrolled')
        }
      })
    }

    // generic carousel
    $('.carousel').each(function() {
      var $carousel = $(this)
      if ($carousel.children().length > 1) {
        var $container = $carousel.parent()
        var flickityOptions = {
          cellSelector: 'img',
          pageDots: false,
          prevNextButtons: false,
          percentPosition: false,
          autoPlay: 0,
          imagesLoaded: true,
          adaptiveHeight: true,
          fade: false,
          wrapAround: true,
          draggable: true
        }
        if ($carousel.hasClass('carousel-renderings')) {
          flickityOptions.cellSelector = '.carousel-cell'
          flickityOptions.setGallerySize = false
        }
        if ($carousel.hasClass('carousel-project')) {
          var carouselDefaultIndex = getUrlParameter('carousel-index')
          if (carouselDefaultIndex) {
            flickityOptions.initialIndex = carouselDefaultIndex
          }
          var mediaId = getUrlParameter('media-id')
          if (mediaId) {
            var cellIndex = $carousel.find('img[data-media-id="' + mediaId + '"]').index()
            if (cellIndex) {
              flickityOptions.initialIndex = cellIndex
            }
          }

        }
        var $carouselItem = $carousel.flickity(flickityOptions)
        $container.find('.previous').on('click', function() {
          $carouselItem.flickity('previous')
        })
        $container.find('.next').on('click', function() {
          $carouselItem.flickity('next')
        })
      }
    })

    // #positions hash - scroll to studio careers
    if (window.location.hash == '#positions') {
      $('html, body').animate({ scrollTop: $('#positions').offset().top - 72 }, 300)
    }

    // #submenu hash - scroll to image content
    if (window.location.hash == '#submenu') {
      $('html, body').animate({ scrollTop: $('.views').offset().top - 100 }, 300)
    }

    // newsletter-signup-toggle
    $('.newsletter-signup-toggle').off('click').on('click', function(e) {
      e.preventDefault()
      $('body').toggleClass('newsletter-signup--is-open')
      if ($('body').hasClass('newsletter-signup--is-open')) {
        var scrollTop = $('body').height()
        setTimeout(function() {
          $('html, body').animate({ scrollTop: scrollTop }, 500)
        }, 500)
      }
    })

    // password form toggle
    $('.password-form-container span').on('click', function() {
      $('.password-form-container').toggleClass('password-form-container--password-is-showing')
      if ($('.password-form-container').hasClass('password-form-container--password-is-showing')) {
        $('.password-form-container input[name="post_password"]').attr('type', 'text')
      } else {
        $('.password-form-container input[name="post_password"]').attr('type', 'password')
      }
    })

    $('.carousel-logos-container').each(function() {
        var $carouselContainer = $(this)
        var $carousel = $carouselContainer.find('.carousel-logos')
        $carousel.flickity({
          cellSelector: '.carousel-cell',
          pageDots: false,
          prevNextButtons: false,
          imagesLoaded: true,
          resize: true,
          fade: false,
          wrapAround: true,
          draggable: true,
      })
      $carouselContainer.find('.previous').on('click', function(e) {
        $carousel.flickity('previous')
        e.preventDefault()
        e.stopPropagation()
      })
      $carouselContainer.find('.next').on('click', function(e) {
        $carousel.flickity('next')
        e.preventDefault()
        e.stopPropagation()
      })
    })

  }


  // mobile menu
  $('header a.mobile-toggle').on('click', function(e) {
    $('body').toggleClass('mobile-menu--is-open')
    e.preventDefault()
  })

  // debugger
  $(window).on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

  // How to get URL parameter using jQuery or plain JavaScript?
  // https://stackoverflow.com/questions/19491336/how-to-get-url-parameter-using-jquery-or-plain-javascript

})

// prevent context menu
document.addEventListener('DOMContentLoaded', function() {
  const elements = document.querySelectorAll('.prevent-download');
  elements.forEach(element => {
      element.addEventListener('contextmenu', function(e) {
          e.preventDefault();
      });
  });
});